export enum userStatus {
  accepted = 1,
  pending = 2,
  declined = 3,
  rescheduleRequest = 4
}
export enum productType {
  meeting = 41,
  webinar = 27,
  event = 7,
  cme = 8
}
export enum meetingStatus {
  meetingNotStarted = 0,
  meetingStarted = 1,
  meetingEnded = 2,
  meetingExpired = 3
}
export enum meetingType {
  online = 2,
  offline = 1
}
